module.exports = __webpack_public_path__ + "img/new-guide-02-2.601f5e91.png";